import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useState } from 'react';
import { View, Text } from 'react-native';
import * as RNStyle from '../../../styles/rn';
import { CustomStyleSheet, getRealPx } from '../../../utils/rn/tools';
import { Image } from '../../Image/rn';
var BorderBottom = function BorderBottom() {
  return /*#__PURE__*/React.createElement(View, {
    style: {
      borderBottomWidth: 1,
      borderStyle: 'solid',
      borderBottomColor: 'rgba(0, 0, 0, 0.09)',
      transform: [{
        scaleY: getRealPx(1)
      }],
      width: '100%'
    }
  });
};
export var TrackCaseCard = function TrackCaseCard(props) {
  var _props$case_status = props.case_status,
    case_status = _props$case_status === void 0 ? '' : _props$case_status,
    _props$case_title = props.case_title,
    case_title = _props$case_title === void 0 ? '' : _props$case_title,
    _props$hint_text = props.hint_text,
    hint_text = _props$hint_text === void 0 ? '' : _props$hint_text,
    _props$image = props.image,
    image = _props$image === void 0 ? '' : _props$image,
    _props$update_time = props.update_time,
    update_time = _props$update_time === void 0 ? '' : _props$update_time,
    _props$enquiryIDText = props.enquiryIDText,
    enquiryIDText = _props$enquiryIDText === void 0 ? '' : _props$enquiryIDText,
    _props$enquiry_id = props.enquiry_id,
    enquiry_id = _props$enquiry_id === void 0 ? '' : _props$enquiry_id;
  var _useState = useState(!image),
    _useState2 = _slicedToArray(_useState, 2),
    imageError = _useState2[0],
    setImageError = _useState2[1];
  return /*#__PURE__*/React.createElement(View, {
    style: styles.container
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.title
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles['title-name'],
    numberOfLines: 1
  }, case_title), /*#__PURE__*/React.createElement(Text, {
    style: styles['title-status']
  }, case_status)), /*#__PURE__*/React.createElement(BorderBottom, null), /*#__PURE__*/React.createElement(View, {
    style: _objectSpread(_objectSpread({}, styles.content), {}, {
      paddingTop: imageError ? 10 : 8
    })
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.order
  }, imageError ? null : /*#__PURE__*/React.createElement(Image, {
    src: image,
    styles: {
      imageStyle: styles['order-img'],
      errorSvgStyle: styles['order-img']
    },
    onError: function onError() {
      return setImageError(true);
    }
  }), /*#__PURE__*/React.createElement(Text, {
    style: styles['order-text'],
    numberOfLines: 2
  }, hint_text)), /*#__PURE__*/React.createElement(View, {
    style: styles.info
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles['enquiry-id']
  }, enquiryIDText, ": ", enquiry_id), /*#__PURE__*/React.createElement(Text, {
    style: styles['update-time']
  }, update_time))));
};
var fullContentPaddingHorizontal = 10; // paddingHorizontal

var fullContentPaddingTop = 8;
var fullContentPaddingBottom = 8;
var styles = CustomStyleSheet({
  container: {
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: 12
  },
  title: {
    height: 34,
    paddingTop: fullContentPaddingTop,
    paddingBottom: 8,
    paddingHorizontal: fullContentPaddingHorizontal,
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    overflow: 'hidden',
    alignItems: 'center'
  },
  'title-name': _objectSpread(_objectSpread({}, RNStyle.FONT_WEIGHT_MEDIUM), {}, {
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.87)',
    lineHeight: 16,
    flex: 1,
    marginRight: 8
  }),
  'title-status': _objectSpread(_objectSpread({}, RNStyle.FONT_WEIGHT_REGULAR), {}, {
    fontSize: 12,
    color: 'rgba(238, 77, 45, 1)',
    lineHeight: 14
  }),
  content: {
    paddingHorizontal: fullContentPaddingHorizontal,
    paddingTop: 8,
    paddingBottom: fullContentPaddingBottom
  },
  order: {
    // height: 40,
    flexDirection: 'row',
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  'order-img': {
    width: 40,
    height: 40,
    borderRadius: 6,
    marginRight: 8
  },
  'order-text': _objectSpread(_objectSpread({}, RNStyle.FONT_WEIGHT_REGULAR), {}, {
    fontSize: 14,
    lineHeight: 16,
    color: 'rgba(0, 0, 0, 0.87)',
    flex: 1
  }),
  info: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    // alignItems: 'center',
    marginTop: 6
  },
  'enquiry-id': _objectSpread(_objectSpread({}, RNStyle.FONT_WEIGHT_REGULAR), {}, {
    fontSize: 10,
    lineHeight: 12,
    color: 'rgba(0, 0, 0, 0.4)',
    flex: 1
  }),
  'update-time': _objectSpread(_objectSpread({}, RNStyle.FONT_WEIGHT_REGULAR), {}, {
    fontSize: 10,
    lineHeight: 12,
    color: 'rgba(0, 0, 0, 0.4)',
    flexShrink: 0,
    marginLeft: 8
  })
});